import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import {Sort} from '@angular/material/sort';
import { DataService } from "./data.service";
import * as HSET from "./settings";
import { GenericUtils } from "../../../utilities/generic-utils";
import { CommonService } from "../../../services/common.service";
import { ActivatedRoute, Params } from "@angular/router";
import { Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

export interface InterfaceWidgetOrderDistribution {
  region: string;
  total_units: number;
  delivered_units: number;
  in_transit_units: number;
  bbnd_units: number;
  to_be_invoiced_units: number;
}

@Component({
  selector: 'widget-table-order-distribution',
  templateUrl: './widget-table-order-distribution.component.html',
  styleUrls: ['./widget-table-order-distribution.component.scss']
})
export class WidgetTableOrderDistributionComponent implements OnInit, OnChanges, OnDestroy {
  @Input() WIDGETCONFIG = null;
  @Input() TABLECONFIG: object[] = [];
  @Input() TITLE: string;
  @Input() FILTERS: object = {};
  data = null;
  errorMessage = "";
  mockData = [HSET.data.region, HSET.data.area, HSET.data.warehouse]
  orderDistributionData = [];
  types = ['region', 'area', 'client_facility_code'];
  activeTab = 'Region';

  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private dataService: DataService,
    private utils: GenericUtils,
    private commonservice: CommonService,
    private activateRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    const intiFilter = JSON.parse(JSON.stringify(this.FILTERS));
    // this.activateRoute.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe((params: Params) => {
    //   if (Object.keys(params).length) {
    //     this.FILTERS = this.commonservice.getFiltersParams(params, this.FILTERS);
    //     const fcCode = this.FILTERS['origin_fc_code'];
    //     if (fcCode) {
    //       this.FILTERS['origin_fc_code'] = fcCode.split(' / ')[1] ? fcCode.split(' / ')[1] : fcCode;

    //     }   
    //     this.FILTERS = this.utils.cleanNullKeys(this.FILTERS);
    //     this.getOrderDistributionData();
    //   } else {
    //     this.FILTERS = JSON.parse(JSON.stringify(intiFilter));
    //     this.getOrderDistributionData();
    //   }
    // })
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getData();
  }

  sortData(sort: Sort, i) {
    const data = this.orderDistributionData[i].data.slice();
    if (!sort.active || sort.direction === '') {
      this.TABLECONFIG[i]['data'] = [...data.slice(0, 10), ...this.orderDistributionData[i].total];
      return;
    }

    this.TABLECONFIG[i]['data'] = [...data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Region': return this.compare(a.region, b.region, isAsc);
        case 'Area': return this.compare(a.area, b.area, isAsc);
        case 'Warehouse': return this.compare(a.client_facility_code, b.client_facility_code, isAsc);
        case 'Total Units Ordered': return this.compare(a.total, b.total, isAsc);
        case 'Delivered': return this.compare(a.delivered, b.delivered, isAsc);
        case 'InTransit': return this.compare(a.in_transit, b.in_transit, isAsc);
        case 'BBND': return this.compare(a.invoiced, b.invoiced, isAsc);
        case 'To be invoiced': return this.compare(a.to_be_invoiced, b.to_be_invoiced, isAsc);
        default: return 0;
      }
    }).slice(0, 10),
    ...this.orderDistributionData[i].total
    ]
  }


  compare(a: number | string, b: number | string, isAsc: boolean) {
    return this.compareItems(a, b) * (isAsc ? 1 : -1);
  }

  private compareItems(itemA: any, itemB: any): number {
    let retVal: number = 0;
    if (itemA && itemB) {
      if (itemA > itemB) retVal = 1;
      else if (itemA < itemB) retVal = -1;
    }
    else if (itemA) retVal = 1;
    else if (itemB) retVal = -1;
    return retVal;
  }

  getData() {
    this.errorMessage = "";
    this.data = null;
    const query = JSON.parse(JSON.stringify(this.FILTERS));
    query.limit = "7";
    this.dataService
      .getData(this.TABLECONFIG, query)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        response => {
          if (response && response.length) {

            response.map((data, i) => {
              let total = 0;
              let delivered = 0;
              let invoiced = 0;
              let inTransit = 0;
              let toBeInvoiced = 0;

              if(data.data && data.data.length){
                data.data.map(__data => {
                  __data.total = isNaN(__data.total) ? 0 : __data.total;
                  __data.cancelled = isNaN(__data.cancelled) ? 0 : __data.cancelled;
                  __data.total = __data.total - __data.cancelled;

                  total += __data.total;
                  delivered += isNaN(__data.delivered) ? 0 : __data.delivered;
                  invoiced += isNaN(__data.invoiced) ? 0 : __data.invoiced;
                  inTransit += isNaN(__data.in_transit) ? 0 : __data.in_transit;
                  toBeInvoiced += isNaN(__data.to_be_invoiced) ? 0 : __data.to_be_invoiced;

                });
                this.orderDistributionData[i] = {
                  data: data.data
                };
                let type = this.types[i];
                this.TABLECONFIG[i]['data'] = [
                  ...data.data.slice(0, 10),
                  ...[
                    {
                      [type]: 'Total',
                      total,
                      delivered,
                      invoiced,
                      in_transit: inTransit,
                      to_be_invoiced: toBeInvoiced
                    }
                  ]
                ];
                this.orderDistributionData[i].total = {
                  [type]: 'Total',
                  total,
                  delivered,
                  invoiced,
                  in_transit: inTransit,
                  to_be_invoiced: toBeInvoiced
                }
              }else{
                this.TABLECONFIG[i]['data'] = null;
                this.TABLECONFIG[i]['errorMessage'] = "ERROR_MSG.NO_DATA";
              }
          });
        } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.TABLECONFIG.map(data => {
              data['data'] = null;
              data['errorMessage'] = "ERROR_MSG.NO_DATA";
            });
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.TABLECONFIG.map(data => {
            data['data'] = null;
            data['errorMessage'] = "ERROR_MSG.NO_DATA";
          });
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


}
